
import { Truck, AlertTriangle } from 'lucide-react';

const MobileWarning = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-900 to-blue-700 flex items-center justify-center p-6">
      <div className="bg-white rounded-xl shadow-2xl p-8 max-w-md w-full text-center">
        <div className="w-20 h-20 bg-blue-100 rounded-full mx-auto mb-6 flex items-center justify-center">
          <Truck className="w-10 h-10 text-blue-600" />
        </div>
        <h1 className="text-2xl font-bold text-gray-900 mb-4">
          Dashboard Dispecer
        </h1>
        <div className="w-16 h-16 bg-red-100 rounded-full mx-auto mb-4 flex items-center justify-center">
          <AlertTriangle className="w-8 h-8 text-red-600" />
        </div>
        <h2 className="text-xl font-semibold text-gray-800 mb-3">
          Acces restricționat
        </h2>
        <p className="text-gray-600 mb-6 leading-relaxed">
          Acest dashboard este optimizat pentru utilizare pe desktop. Pentru o experiență completă și funcționalitate deplină, vă rugăm să accesați aplicația de pe un computer.
        </p>
        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
          <p className="text-blue-800 text-sm font-medium">
            💻 Rezoluție minimă recomandată: 1024x768px
          </p>
        </div>
      </div>
    </div>
  );
};

export default MobileWarning;